import { useMemo } from 'react';
import { Helmet } from 'react-helmet';
import { NavLink, useParams, useLocation, Link } from 'react-router-dom';

import { Badge, Button } from 'twyne-new.ui'

import HeaderContainerGrid from '@/components/headerContainer/Grid';

import { useTagStore } from '../store';

function TagsGrid() {
  const { content_type } = useParams()
  const { pathname } = useLocation()
  const { collections: { items, useLoad } } = useTagStore()

  const params = useMemo(() => {
    pathname; // keep to force load on route change
    return { content_type, autoRefresh: false }
  }, [content_type, pathname])

  useLoad(params)

  return <>
    <AddTagButton contentType={content_type} />
    <div className='max-h-[calc(100vh-7.5rem)] overflow-y-auto'>
      {items.map(tag => <>
        <NavLink to={`/cms/${content_type}/tags/${tag.id}`} activeClassName="border-l-2 border-blue-500 dark:border-blue-400">
          <div className="p-4 border-b twy-border-base twy-subtle-neutral-hover w-full flex gap-2" key={tag.id}>
            {tag.name}
            <Badge color='accent' size='sm'>{`/${content_type}/tag/${tag.slug}`}</Badge>
          </div>
        </NavLink>
      </>)}
    </div>
  </>
}

const AddTagButton = ({ contentType }) => <>
  <Helmet title="Categories" />
  <HeaderContainerGrid title='Categories'>
    <Link to={`/cms/${contentType}/tags/add`}>
      <Button size='lg' color='accent'>
        Add Category
      </Button>
    </Link>
  </HeaderContainerGrid>
</>

export default TagsGrid
